import classNames from "classnames";
import { useTranslations } from "next-intl";
import { useState } from "react";

import CommonUtils from "~/utils/common-utils";

import Icon from "../common/icon";
import styles from "./category-filters.module.scss";
import CategorySortDialog from "./category-sort-dialog";
import SearchFilterDialog from "./search-filter-dialog";
import SearchSortDialog from "./search-sort-dialog";

type Props = {
  pageType: "inSearch" | "inPLPEva" | "inPLPAlgolia";
};

export default function CategoryFilters(props: Props) {
  const t = useTranslations();
  const [isSorting, setSorting] = useState(false);

  const isAlgoliaSearchPage =
    !CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_ALGOLIA) && props.pageType === "inSearch";
  const isEvaSearchPage =
    CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_ALGOLIA) && props.pageType === "inSearch";

  const isAlgoliaPLPPage = props.pageType === "inPLPAlgolia";

  const isEvaPLPPage = props.pageType === "inPLPEva";

  return (
    <div className={classNames(styles.container, styles.single)}>
      {isAlgoliaSearchPage && (
        <SearchFilterDialog
          disableFilters={CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_FILTERS_ALGOLIA_SEARCH)}
        />
      )}
      {isAlgoliaPLPPage && (
        <SearchFilterDialog
          disableFilters={CommonUtils.parseBoolean(process.env.NEXT_PUBLIC_DISABLE_FILTERS_ALGOLIA_PRODUCT_LISTING)}
        />
      )}
      {(isEvaSearchPage || isEvaPLPPage) && (
        <>
          <button type="button" className={styles.cta} onClick={() => setSorting(true)}>
            <Icon name="sort" width={16} height={16} aria-hidden />
            {t("generic.sort_by")}
          </button>
          {isEvaSearchPage && <SearchSortDialog isOpen={isSorting} setOpen={setSorting} />}
          {isEvaPLPPage && <CategorySortDialog isOpen={isSorting} setOpen={setSorting} />}
        </>
      )}
    </div>
  );
}
